


























































































































































































































import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import SideNavVue from "../components/SideNav.vue";
@Component({
    ...mapGetters(["account"]),
    components: {
        "side-nav": SideNavVue
    }
})
export default class DashBoard extends Vue {
    date: string = "";
    AccountingRed: string = "";
    AccountingGreen: string = "";
    AccountingYellow: string = "";

    chargeRed: string = "";
    chargeGreen: string = "";
    chargeYellow: string = "";

    taxRed: string = "";
    taxGreen: string = "";
    taxYellow: string = "";

    accounterNo: any = 0;
    scope: any = "all";
    param: any = {
        chargeStatus: undefined,
        accountStatus: undefined,
        taxStatus: undefined,
        accounterNo: "",
        scope: "",
        name: ""
    };

    mounted() {
        this.accounterNo = this.$store.state.account.no;
        this.getData();
        this.jf();
        this.$store.dispatch("initAccounBook");
    }
    // methods
    getData() {
        Vue.axios({
            url: "accounts/getindexmessages",
            method: "POST",
            data: {
                accounterNo: this.accounterNo,
                scope: this.scope
            }
        }).then(res => {
            this.AccountingGreen = res.data.jzGreen;
            this.AccountingRed = res.data.jzRed;
            this.AccountingYellow = res.data.jzYellow;

            this.chargeGreen = res.data.sfGreen;
            this.chargeRed = res.data.sfRed;
            this.chargeYellow = res.data.sfYellow;

            this.taxGreen = res.data.bsGreen;
            this.taxRed = res.data.bsRed;
            this.taxYellow = res.data.bsYellow;

            this.canvasShow(
                "canvas",
                this.chargeGreen,
                this.chargeRed,
                this.chargeYellow
            );
            this.canvasShow(
                "canvas1",
                this.AccountingGreen,
                this.AccountingRed,
                this.AccountingYellow
            );
            this.canvasShow(
                "canvas2",
                this.taxGreen,
                this.taxRed,
                this.taxYellow
            );

            this.date = Vue.utils.simpleDateFormat(new Date(), "m", true);
        });
    }
    name: string = "";
    refreshData(item: any) {
        this.accounterNo = item.no;
        this.scope = item.scope;
        this.name = item.name
        this.getData();
    }
    canvasShow(id: string, num1: any, num2: any, num3: any) {
        let c: any = document.getElementById(id);
        let ctx = c.getContext("2d");
        let end1 = (num1 / (num1 + num2 + num3)) * 360 - 90;
        let end2 = ((num2 + num1) / (num1 + num2 + num3)) * 360 - 90;

        ctx.lineWidth = 30;
        ctx.strokeStyle = "#5AD8A6";
        ctx.beginPath();
        ctx.arc(100, 100, 75, -Math.PI / 2, (Math.PI / 180) * end1, false);
        ctx.stroke();
        ctx.closePath();

        ctx.lineWidth = 30;
        ctx.strokeStyle = "#F4775D";
        ctx.beginPath();
        ctx.arc(
            100,
            100,
            75,
            (Math.PI / 180) * end1,
            (Math.PI / 180) * end2,
            false
        );
        ctx.stroke();
        ctx.closePath();

        ctx.lineWidth = 30;
        ctx.strokeStyle = "#F6BD16";
        ctx.beginPath();
        ctx.arc(100, 100, 75, (Math.PI / 180) * end2, (3 * Math.PI) / 2, false);
        ctx.stroke();
        ctx.closePath();
    }
    toAccountBookList(param: any) {
        this.$router.push({ path: "/accountbooklist", query: param })
    }
    changeToPointer(event: any, id: string) {
        let canvas: any = document.getElementById(id);
        let ctx = canvas.getContext("2d");
        let mousePos = this.getMousePos(canvas, event);
        var imgData = ctx.getImageData(
            Math.floor(mousePos.x),
            Math.floor(mousePos.y),
            1,
            1
        );
        if (imgData.data[1] != 0) {
            event.currentTarget.style.cursor = "pointer";
        } else {
            event.currentTarget.style.cursor = "";
        }
    }
    getColor(event: any, id: string) {
        let canvas: any = document.getElementById(id);
        let ctx = canvas.getContext("2d");
        let mousePos = this.getMousePos(canvas, event);
        var imgData = ctx.getImageData(
            Math.floor(mousePos.x),
            Math.floor(mousePos.y),
            1,
            1
        );

        this.param.accounterNo = this.accounterNo;
        this.param.scope = this.scope;
        this.param.name = this.name;
        if (id == "canvas") {
            this.param.accountStatus = undefined;
            this.param.taxStatus = undefined;
            if (imgData.data[0] == 187) {
                this.param.chargeStatus = 1;
                this.$router.push({
                    path: "/accountbooklist",
                    query: this.param
                });
            } else if (imgData.data[0] == 249) {
                this.param.chargeStatus = 2;
                this.$router.push({
                    path: "/accountbooklist",
                    query: this.param
                });
            } else if (imgData.data[0] == 251) {
                this.param.chargeStatus = 3;
                this.$router.push({
                    path: "/accountbooklist",
                    query: this.param
                });
            }
        } else if (id == "canvas1") {
            this.param.chargeStatus = undefined;
            this.param.taxStatus = undefined;
            if (imgData.data[0] == 187) {
                this.param.accountStatus = 3;
                this.$router.push({
                    path: "/accountbooklist",
                    query: this.param
                });
            } else if (imgData.data[0] == 249) {
                this.param.accountStatus = 1;
                this.$router.push({
                    path: "/accountbooklist",
                    query: this.param
                });
            } else if (imgData.data[0] == 251) {
                this.param.accountStatus = 2;
                this.$router.push({
                    path: "/accountbooklist",
                    query: this.param
                });
            }
        } else {
            this.param.chargeStatus = undefined;
            this.param.accountStatus = undefined;
            if (imgData.data[0] == 187) {
                this.param.taxStatus = 1;
                this.$router.push({
                    path: "/accountbooklist",
                    query: this.param
                });
            } else if (imgData.data[0] == 249) {
                this.param.taxStatus = 2;
                this.$router.push({
                    path: "/accountbooklist",
                    query: this.param
                });
            } else if (imgData.data[0] == 251) {
                this.param.taxStatus = 3;
                this.$router.push({
                    path: "/accountbooklist",
                    query: this.param
                });
            }
        }
    }
    getMousePos(canvas: any, evt: any) {
        let rect = canvas.getBoundingClientRect();
        return {
            x: evt.clientX - rect.left,
            y: evt.clientY - rect.top
        };
    }
    async jf() {
        const res = await Vue.axios.get(`https://fc.hongfund.com:8802/vip/money/count?accountNo=${this.$store.state.account.no}`);
        localStorage.setItem("jf", res.data.data || "0");
    }
}
